<template>
  <div class="container-fluid">
    <!-- <div class="row page-title align-items-center">
      <div class="col-md-3 col-xl-6" v-if="user.role.role == 'administration'">
        <button class="btn btn-warning mr-1 mb-3 mb-sm-0" @click="syncData">
          <i class="uil-sync mr-1"></i> {{$t('company.action.sync')}}
        </button>
      </div>
    </div> -->
    <div class="row">
      <div class="col-sm-12 col-xl-12">
        <DataTable :sent="sentTab" ref="list"/>
      </div>
    </div>
  </div>
</template>

<script>
  import DataTable from '@common/datatable4'

  export default {
    components: { DataTable },
    data() {
      return {
        sentTab: false
      }
    },
    methods: {
      setActiveTab(value){
        this.sentTab = value
      },
      syncData(){
        this.$refs.list.syncDatas()
      }
    }
  }
</script>